export default __webpack_public_path__ + "static/media/LeekHotPot_03.243cffcf.png";